export default __webpack_public_path__ + "static/media/close.5660fc33.svg";